<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<hr>
<div style="display: flex; flex-direction: column; height: calc(95% - 15px); position: relative;">
	<div style="overflow-y: auto; flex: 1;">
		<mat-nav-list appAccordion *ngFor="let menuitem of menus" style="padding: unset;">
			<div *ngIf="this.toolsService.userInRol(menuitem.roles)">
				<mat-list-item appAccordionLink *ngIf="menuitem.type == 'link'" routerLinkActive="selected">
					<a class="" appAccordionToggle [routerLink]="[menuitem.controller, menuitem.state]" *ngIf="menuitem.type === 'link'"  (click)="toggleExpansion()">
						<mat-icon>{{ menuitem.icon }}</mat-icon>
						<span class="hid">{{ menuitem.name }}</span>
					</a>
				</mat-list-item>
				
				<mat-expansion-panel appAccordionLink [expanded]="menuitem.expanded" *ngIf="menuitem.type === 'container'" [class.mat-elevation-z0]="true">
					<mat-expansion-panel-header appAccordionLink>
						<mat-icon style="color: #0661b3;">{{ menuitem.icon }}</mat-icon>&nbsp;&nbsp;&nbsp;<span style="font-size: 15px; color:#0661b3; font-weight:normal" class="hid">{{ menuitem.name }}</span>
					</mat-expansion-panel-header>
					<div *ngFor="let submenitem of menuitem.content">
						<div *ngIf="this.toolsService.userInRol(submenitem.roles)">
							<mat-list-item style="padding: unset;margin-left: -5%;" appAccordionLink  routerLinkActive="selected">  
								<a class="" appAccordionToggle [routerLink]="[submenitem.controller, submenitem.state]" (click)="toggleExpansion(menuitem.id)">
									<mat-icon>{{ submenitem.icon }}</mat-icon>
									<span class="hid">{{ submenitem.name }}</span>
								</a>
							</mat-list-item>
						</div>
					</div>
				</mat-expansion-panel>
			</div>
		</mat-nav-list>
	</div>
	<div class="version-wrapper" style="padding: 10px;">
		<app-version></app-version>
	</div>
</div>
<hr>